import 'lib/shopify'
import 'component/_adaptive-image'
import 'component/_broadcast'
import 'component/_columns'
import 'component/_slider'
import 'component/_tooltip'
import 'component/_product-card'
import 'component/_modal'
import 'component/_details-modal'
import 'component/_header'
import 'component/_sticky-header'
import 'component/_localization-form'
import 'component/_focus-trap'
import 'component/_input-wrapper'
import 'component/_checkbox-wrapper'
import 'component/_custom-select'

import { importOnIntersection, lowPriority } from 'lib/performance'
import { VIEW_CART_PARAM } from 'constants'
import { callOnReady, initAnchor } from 'utils/gw'
import { toggleCart } from 'utils/shopify'
import { NostoHelper } from 'helpers/nosto'
import freeShippingManager from 'utils/free-shipping-threshold'
import DynamicStickyElement from 'lib/dynamic-sticky-element'
import 'vendor/lit'

window.remBase = parseInt(getComputedStyle(document.documentElement).getPropertyValue('font-size'), 10)

// iOS input zoom fix
if (navigator.userAgent.indexOf('iPhone') > -1) {
  document
    .querySelector('[name=viewport]')
    .setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
}

const searchParams = new URLSearchParams(window.location.search)
const loadScripts = searchParams.has('loadscripts') && searchParams.get('loadscripts') !== 'false'

callOnReady(() => {
  // TODO: Probably remove this
  // window.intersectionImports.forEach((entry) => {
  //   importOnIntersection(...entry)
  // })

  const intersectionImportElements = document.querySelectorAll('[data-intersection-import]')
  intersectionImportElements.forEach(element => {
    const { script, offset } = element.dataset
    const intersection = element.hasAttribute('data-intersection')
    const loadOnIdle = intersection ? element.dataset.idle : true
    // console.log(
    //   'importOnIntersection',
    //   script,
    //   intersection,
    //   intersection ? element : false
    // )
    console.log('IMPORTING ON INTERSECTION', script)
    importOnIntersection(script, intersection ? element : false, {
      offset,
      loadOnIdle,
      instant: loadScripts,
    })
  })

  if (searchParams.has(VIEW_CART_PARAM) && searchParams.get(VIEW_CART_PARAM) !== 'false') {
    toggleCart(true)
  }

  document.querySelectorAll(`a[href^="#"], a[href^="${window.location.pathname}#"]`).forEach(initAnchor)

  const enhanceNostoNavigation = (root = document) => {
    const controls = [
      ...(root.matches?.('.nosto_element .swiper-button-prev, .nosto_element .swiper-button-next') ? [root] : []),
      ...(root.querySelectorAll?.('.nosto_element .swiper-button-prev, .nosto_element .swiper-button-next') || []),
    ]

    controls.forEach(control => {
      const isPrevious = control.classList.contains('swiper-button-prev')
      const isDisabled = control.classList.contains('swiper-button-disabled')

      control.setAttribute('role', 'button')
      control.setAttribute('aria-label', window.accessibilityStrings[isPrevious ? 'previousSlide' : 'nextSlide'])
      control.setAttribute('aria-disabled', String(isDisabled))
      control.setAttribute('tabindex', isDisabled ? '-1' : '0')

      if (control.dataset.keyboardInitialized) return
      control.addEventListener('keydown', event => {
        if (!['Enter', ' '].includes(event.key) || control.getAttribute('aria-disabled') === 'true') return
        event.preventDefault()
        control.click()
      })
      control.dataset.keyboardInitialized = 'true'
    })
  }

  enhanceNostoNavigation()
  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') {
        enhanceNostoNavigation(mutation.target)
        return
      }
      mutation.addedNodes.forEach(node => {
        if (node instanceof Element) enhanceNostoNavigation(node)
      })
    })
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] })

  const initializeAccountDrawerAccessibility = () => {
    const accountHost = document.querySelector('#GWCustomerAccountsDrawer')
    const accountRoot = accountHost?.shadowRoot
    const mainDrawer = accountRoot?.querySelector('sl-drawer[main-drawer]')
    if (!accountRoot || !mainDrawer) {
      setTimeout(initializeAccountDrawerAccessibility, 250)
      return
    }

    const triggers = [...document.querySelectorAll('[data-gw-drawer-trigger]')]
    let inertedBackgroundElements = []
    let drawerOpener = null

    const syncPanel = drawer => {
      const panel = drawer.shadowRoot?.querySelector('.drawer__panel')
      if (!panel) return

      const open = drawer.hasAttribute('open')
      const tabIndex = open ? '0' : '-1'
      if (panel.getAttribute('tabindex') !== tabIndex) panel.setAttribute('tabindex', tabIndex)
      if (panel.hasAttribute('inert') === open) panel.toggleAttribute('inert', !open)
    }

    const syncMainDrawer = open => {
      triggers.forEach(trigger => {
        const isCurrentTrigger = trigger.dataset.gwDrawerTrigger === window.location.hash
        trigger.setAttribute('aria-expanded', String(open && isCurrentTrigger))
      })

      if (open && !inertedBackgroundElements.length) {
        inertedBackgroundElements = [
          document.querySelector('#main'),
          document.querySelector('.header-wrapper'),
          document.querySelector('.site-footer-wrapper'),
        ].filter(element => element && !element.hasAttribute('inert'))
        inertedBackgroundElements.forEach(element => element.setAttribute('inert', ''))
      } else if (!open) {
        inertedBackgroundElements.forEach(element => element.removeAttribute('inert'))
        inertedBackgroundElements = []
        requestAnimationFrame(() => drawerOpener?.focus())
      }
    }

    const enhanceDrawer = drawer => {
      syncPanel(drawer)
      const panel = drawer.shadowRoot?.querySelector('.drawer__panel')
      if (!panel || drawer.dataset.accessibilityObserved) return

      new MutationObserver(() => syncPanel(drawer)).observe(panel, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'tabindex'],
      })
      new MutationObserver(() => {
        syncPanel(drawer)
        if (drawer === mainDrawer) syncMainDrawer(drawer.hasAttribute('open'))
      }).observe(drawer, { attributes: true, attributeFilter: ['open'] })
      drawer.dataset.accessibilityObserved = 'true'
    }

    accountRoot.querySelectorAll('sl-drawer').forEach(enhanceDrawer)
    syncMainDrawer(mainDrawer.hasAttribute('open'))

    accountRoot.addEventListener('sl-show', event => {
      if (!event.target.matches('sl-drawer')) return
      requestAnimationFrame(() => {
        enhanceDrawer(event.target)
        if (event.target === mainDrawer) syncMainDrawer(true)
      })
    })
    accountRoot.addEventListener('sl-hide', event => {
      if (!event.target.matches('sl-drawer')) return
      if (event.target === mainDrawer) syncMainDrawer(false)
      requestAnimationFrame(() => enhanceDrawer(event.target))
    })

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        drawerOpener = trigger
        const hash = trigger.dataset.gwDrawerTrigger
        if (window.location.hash === hash) {
          window.dispatchEvent(new HashChangeEvent('hashchange'))
        } else {
          window.location.hash = hash
        }
      })
    })

    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return
          if (node.matches('sl-drawer')) enhanceDrawer(node)
          node.querySelectorAll?.('sl-drawer').forEach(enhanceDrawer)
        })
      })
    }).observe(accountRoot, { childList: true, subtree: true })
  }

  initializeAccountDrawerAccessibility()

  if (Shopify.currency.active !== 'USD') {
    const pricesForConversion = [...document.querySelectorAll('[data-price-for-conversion]')]
    for (const priceEl of pricesForConversion) {
      const priceUSD = priceEl.dataset.priceForConversion
      const price = priceUSD * Shopify.currency.rate
      priceEl.innerHTML = Shopify.formatMoney(price * 100)
    }
  }

  // Initialize free shipping threshold manager with GlobalE API
  if (window.Shopify?.country !== 'US') {
    freeShippingManager.init().catch(error => {
      console.error('Failed to initialize free shipping manager:', error)
    })
  }
})

class DelayedScript extends HTMLElement {
  done = false

  constructor() {
    super()
  }

  connectedCallback() {
    this.load()
  }

  get src() {
    return this.getAttribute('src') ?? this.textContent.trim()
  }

  get delay() {
    return parseInt(this.getAttribute('delay') ?? 4, 10)
  }

  async load() {
    if (this.done) return

    const callback = async () => await import(this.src)

    if (loadScripts) {
      callback()
    } else {
      lowPriority(callback, this.delay)
    }

    this.done = true
  }
}
customElements.define('delayed-script', DelayedScript)

new NostoHelper()



// Initialize dynamic sticky element
new DynamicStickyElement()
